import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class AlertBox extends Component {
  static propTypes = {
    dismissable: PropTypes.bool,
    type: PropTypes.string,
    fixed: PropTypes.bool,
    autoHide: PropTypes.bool,
    message: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object,
    ]).isRequired,
    onClick: PropTypes.func,
    style: PropTypes.object,
  }

  static defaultProps = {
    dismissable: true,
    fixed: true,
    autoHide: false,
    type: 'notice',
    onClick() {},
    style: null,
  }

  constructor(props) {
    super(props);
    this.state = { open: !!this.props.message };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ open: !!nextProps.message });
  }

  // On the parent, remove the message so that the component rerenders blank
  handleClick = () => {
    this.props.onClick();

    if (this.props.dismissable) {
      this.setState({ open: false });
    }
  }

  render() {
    const classes = ['AlertBox animated'];
    classes.push(this.props.fixed ? 'AlertBox--fixed' : '');
    classes.push(this.props.autoHide ? 'AlertBox--autohide' : '');
    classes.push(this.props.dismissable ? 'AlertBox--dismissable' : '');
    classes.push(`is-${this.props.type}`);

    return ReactDOM.createPortal(
      <div>
        {this.state.open &&
          <div
            className={classes.join(' ')}
            onClick={this.handleClick}
            style={this.props.style}
          >
            <div className="content">
              { this.props.message }
            </div>
          </div>
        }
      </div>,
      document.getElementById('alerts')
    );
  }
}
